// import localForage from 'localforage'

// let store = window.localForageStore.createInstance({
// 	name        : 'Juniper Notebook',
// 	version     : 1.0,
// 	storeName   : 'prefs', // Should be alphanumeric, with underscores.
// 	description : 'user prefs'
// })

export default window.localforageStore